"use strict";
import Browser from '../util/browser';

class Panorama{
	
	static get IMGPATH() {
		return "img/panorama/panorama.jpg";
	}
  
	constructor(fullscreen){
		this.isRender = false;
		this.firstRenderCount = 0;
		this.fullscreen = fullscreen;
		
		this.$con = $('#Panorama');
		this.$con.on('click',()=>{
			if(Browser.responsive != 'sp'){
				return false;
			} else {
				ga('send', 'event', 'movie', '360camera', '2017');
			}
		})
		
		//scene		
		this.scene = new THREE.Scene();
		
		//geometry
		if(Browser.isIE){
			this.geometry = new THREE.SphereGeometry( 5, 15, 10 );
		} else {
			this.geometry = new THREE.SphereGeometry( 5, 60, 40 );
		}
		
		this.geometry.scale( - 1, 1, 1 );
		
		//material
		var texture = THREE.ImageUtils.loadTexture( Panorama.IMGPATH );
		//texture.minFilter = THREE.LinearFilter;
		//texture.magFilter = THREE.LinearFilter;
		this.material = new THREE.MeshBasicMaterial( {
			map: texture
		} );
		
		//sphere
		this.sphere = new THREE.Mesh( this.geometry, this.material );
		this.scene.add( this.sphere );
		
		//camera
		this.camera = new THREE.PerspectiveCamera(100, Browser.windowWidth / 720, 1, 1000);
		this.camera.position.set(0,0,0.1);
		this.camera.lookAt(this.sphere.position);
		this.target = new THREE.Vector3();
		
		//helper
		//this.axis = new THREE.AxisHelper(1000);
		//this.axis.position.set(0,0,0);
		//this.scene.add(this.axis);
		
		//render
		this.renderer = new THREE.WebGLRenderer();
		this.renderer.setClearColor({color: 0x000000});
		this.$con[0].appendChild(this.renderer.domElement);
		this.renderer.render(this.scene,this.camera);
		
		//control
		//this.controls = new THREE.OrbitControls(this.camera,this.renderer.domElement);
		//this.controls.enableZoom = false;
		
		Browser.addResizeHandler(this.resize , this);
		this.resize();
		
		this.initControll();
		
		this.lon = 0;
		this.lat = 0;
		this.phi = 0;
		this.theta = 0;
		this.gestureScale = 1;
		this.render();
		
		Browser.addResizeHandler(this.scrollresize,this);
		Browser.addResponsiveHandler(this.responsive,this);
		Browser.addScrollHandler(this.scrollresize,this);
		this.responsive();
		this.scrollresize();
	}
	
	render(){
		requestAnimationFrame(this.render.bind(this));
		
		if(!this.isRender){
			if(this.firstRenderCount>50){
				return;
			} else {
				this.firstRenderCount++;
			}
		}
		
		let speed = 0.2;
		if(this.isBtnDown){
			this.lat +=  this.latDelta;
			this.lon +=  this.lonDelta;
		} else if(this.isBtnScaleDown){
			this.camera.fov += this.scaleDelta;
			if(this.camera.fov > 120) this.camera.fov = 120;
			if(this.camera.fov < 30) this.camera.fov = 30;
			this.camera.updateProjectionMatrix();
		} else {
			this.lon +=  0.05;
		}

		
		this.lat = Math.max( - 85, Math.min( 85, this.lat ) );
		this.phi = THREE.Math.degToRad( 90 - this.lat );
		this.theta = THREE.Math.degToRad( this.lon );
		this.target.x = Math.sin( this.phi ) * Math.cos( this.theta );
		this.target.y = Math.cos( this.phi );
		this.target.z = Math.sin( this.phi ) * Math.sin( this.theta );
		this.camera.lookAt( this.target );
		
		this.renderer.render(this.scene,this.camera);
		//this.controls.update();
	}
	
	resize(){
		if(Browser.responsive == 'sp'){
			this.camera.aspect = Browser.windowWidth / Browser.windowHeight;
			this.camera.updateProjectionMatrix();
			this.renderer.setSize( Browser.windowWidth, Browser.windowHeight );			
		} else {
			this.camera.aspect = Browser.windowWidth / 720;
			this.camera.updateProjectionMatrix();
			this.renderer.setSize( Browser.windowWidth, 720 );
		}
	}
	
	initControll(){
		this.$controll = this.$con.find('.controll');
		this.isBtnDown = false;
		this.isBtnScaleDown = false;
		this.lonDelta = 0;
		this.latDelta = 0;
		this.scaleDelta = 0;
		let speed = 0.25;
		let mousedown = Browser.isTouch ? 'touchstart' : 'mousedown';
		let mouseup = Browser.isTouch ? 'touchend' : 'mouseup';
		
		this.$controll.find('.top').on(mousedown,()=>{
			this.isBtnDown = true;
			this.lonDelta = 0;
			this.latDelta = speed;
		});
		this.$controll.find('.top').on(mouseup,()=>{
			this.isBtnDown = false;
		});
		
		this.$controll.find('.bottom').on(mousedown,()=>{
			this.isBtnDown = true;
			this.lonDelta = 0;
			this.latDelta = -speed;
		});
		this.$controll.find('.bottom').on(mouseup,()=>{
			this.isBtnDown = false;
		});
		
		this.$controll.find('.left').on(mousedown,()=>{
			this.isBtnDown = true;
			this.lonDelta = -speed;
			this.latDelta = 0;
		});
		this.$controll.find('.left').on(mouseup,()=>{
			this.isBtnDown = false;
		});
		
		this.$controll.find('.right').on(mousedown,()=>{
			this.isBtnDown = true;
			this.lonDelta = speed;
			this.latDelta = 0;
		});
		this.$controll.find('.right').on(mouseup,()=>{
			this.isBtnDown = false;
		});
		
		this.$controll.find('.plus').on(mousedown,()=>{
			this.isBtnScaleDown = true;
			this.scaleDelta = -speed;
		});
		this.$controll.find('.plus').on(mouseup,()=>{
			this.isBtnScaleDown = false;
		});
		
		this.$controll.find('.minus').on(mousedown,()=>{
			this.isBtnScaleDown = true;
			this.scaleDelta = speed;
		});
		this.$controll.find('.minus').on(mouseup,()=>{
			this.isBtnScaleDown = false;
		});
		
		
		this._onMouseDown = this.onMouseDown.bind(this);
		this._onMouseMove = this.onMouseMove.bind(this);
		this._onMouseUp = this.onMouseUp.bind(this);
		
		this._onTouchStart = this.onTouchStart.bind(this);
		this._onTouchMove = this.onTouchMove.bind(this);
		this._ongestureChange = this.ongestureChange.bind(this);

		 		
		this.renderer.domElement.addEventListener( 'mousedown', this._onMouseDown, false );
		//this.renderer.domElement.addEventListener( 'wheel', onMouseWheel, false );
	
		this.renderer.domElement.addEventListener( 'touchstart', this._onTouchStart, false );
		this.renderer.domElement.addEventListener( 'touchmove', this._onTouchMove, false );
		this.renderer.domElement.addEventListener( 'gesturechange', this._ongestureChange, false );
	}
	
	onMouseDown(e){
		e.preventDefault();
		this.renderer.domElement.addEventListener( 'mousemove', this._onMouseMove, false );
		this.renderer.domElement.addEventListener( 'mouseup', this._onMouseUp, false );
		this.renderer.domElement.addEventListener( 'mouseleave', this._onMouseUp, false );
		
		this.layerX = e.layerX;
		this.layerY = e.layerY;
	}
	
	onMouseMove(e){
		var movementX = e.movementX || e.mozMovementX || e.webkitMovementX || 0;
		var movementY = e.movementY || e.mozMovementY || e.webkitMovementY || 0;
		if(movementX == 0){
			movementX = e.layerX - this.layerX;
		}
		if(movementY == 0){
			movementY = e.layerY - this.layerY;
		}
		
		this.lon -= movementX * 0.1;
		this.lat += movementY * 0.1;
		this.layerX = e.layerX;
		this.layerY = e.layerY;
	}
	
	onMouseUp(e){
		this.renderer.domElement.removeEventListener( 'mousemove', this._onMouseMove );
		this.renderer.domElement.removeEventListener( 'mouseup', this._onMouseUp );
		this.renderer.domElement.removeEventListener( 'mouseleave', this._onMouseUp );
	}
	
	onTouchStart(e){
		e.preventDefault();
		var touch = e.touches[ 0 ];
		this.touchX = touch.screenX;
		this.touchY = touch.screenY;
	}
	
	onTouchMove(e){
		e.preventDefault();
		var touch = e.touches[ 0 ];
		this.lon -= ( touch.screenX - this.touchX ) * 0.15;
		this.lat += ( touch.screenY - this.touchY ) * 0.15;
		this.touchX = touch.screenX;
		this.touchY = touch.screenY;
	}
	
	ongestureChange(e){
		e.preventDefault();
		
		var s = 1 + (e.scale -1)*0.05;
		//this.camera.fov = 1/this.gestureScale * this.fov;
		this.camera.fov = 1/s * this.camera.fov;
		if(this.camera.fov > 120) this.camera.fov = 120;
		if(this.camera.fov < 30) this.camera.fov = 30;
		this.camera.updateProjectionMatrix();
		
	}
	
	responsive(){
		if( Browser.responsive == 'pc' ){
			this.isRender = true;
		} else {
			if(this.fullscreen){
				this.isRender = true;				
			} else {
				this.isRender = false;
			}
		}
	}
	
	scrollresize(){
		//scroll
		if( Browser.responsive == 'pc' || Browser.responsive == 'tb' ){
			let startY = this.$con.offset().top - Browser.windowHeight;
			let endY = startY + this.$con.height() + Browser.windowHeight;
			if( Browser.scrollY >= startY && Browser.scrollY < endY ){
				this.isRender = true;
			} else {
				this.isRender = false;
			}			
		} else {
			if(this.fullscreen){
				this.isRender = true;				
			} else {
				this.isRender = false;
			}
		}
	}
}

export default Panorama;


// WEBPACK FOOTER //
// ./js/three/panorama.js